// Matches a bare or `#`-prefixed 3- or 6-digit hex colour, nothing else. Deliberately narrower
// than Mantine's own `ColorInput` validity check, which also matches hexa/rgb/rgba/hsl/hsla - see
// `usePaletteColourDrafts`'s own comment for why that distinction matters.
const HEX_COLOUR_PATTERN = /^#?[0-9a-f]{3}$|^#?[0-9a-f]{6}$/i;

export function normaliseHexColour(value: string): string | null {
  const trimmed = value.trim();
  if (!HEX_COLOUR_PATTERN.test(trimmed)) {
    return null;
  }
  const digits = trimmed.startsWith('#') ? trimmed.slice(1) : trimmed;
  const sixDigitHex =
    digits.length === 3
      ? digits
          .split('')
          .map(digit => digit + digit)
          .join('')
      : digits;
  return `#${sixDigitHex.toLowerCase()}`;
}
